import countries from '../util/countries'
import currencyList from '../util/currency'
import { getCountryInfo } from '../models'
import timezones from '../util/timezones'
const acceptedLength = 1000000

export const initializeGlobalFilters = (app: any) => {
  app.config.globalProperties.$filters = {
    capitalize: (value: string) => {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    classify: (value: string) => {
      if (!value) return ''
      return value.toLowerCase().replaceAll(' ', '-')
    },
    country(code: string) {
      return countries[code as keyof typeof countries] || code
    },
    formatDecimalValue: (value: any, precision = 2) => {
      const floatValue = parseFloat(value)
      if (floatValue && typeof floatValue === 'number') {
        const precisionLength = precision > 2 ? value / acceptedLength >= 1 ? 2 : precision : precision
        return floatValue.toFixed(precisionLength)
      }
      else return value
    },
    formatNumber: (value: string | number) => {
      if (!value) value = 0
      const locale = getCountryInfo('locale')
      return Number(value).toLocaleString(locale, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      })
    },
    formatNumberNoDecimal: (value: string | number) => {
      if (!value) value = 0
      const locale = getCountryInfo('locale')
      return Number(value).toLocaleString(locale, {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      })
    },
    replaceStorageURL: (value: string) => {
      if (!value) return ''
      return value.indexOf('https://storage.cloud.google.com') === 0
        ? value.replace('https://storage.cloud.google.com', 'https://storage.googleapis.com')
        : value
    },
    roundUpCount: (value: any, precision = 4) => {
      if (!value) return 0
      const number = parseFloat(value)
      if (number % 1 == 0) return number
      const precisionLength = precision > 2 ? value / acceptedLength >= 1 ? 2 : precision : precision
      return number.toFixed(precisionLength);
    },
    str_limit: (value: string, size: number) => {
      if (!value) return ''
      value = value.toString()

      if (value.length <= size) {
        return value
      }
      return value.substr(0, size) + '...'
    },
    symbole: (value: string) => {
      return currencyList[value as keyof typeof currencyList] || '$'
    },
    timezone(zone: string) {
      const store = app.config.globalProperties.$store
      return zone
        ? timezones.find(z => z.value === zone)?.label || zone
        : timezones.find(
          z =>
            z.value === store.getters[`locations/getCurrentLocationTimeZone`],
        )?.label
    },
    toTitleCase: (str: string) => {
      if (str) {
        const words = str.toLowerCase().split(' ')
        for (let i = 0; i < words.length; i++) {
          if (words[i].charAt(0) === '(' && words[i].length > 1) {
            words[i] = words[i].charAt(0) + words[i].charAt(1).toUpperCase() + words[i].slice(2)
          } else {
            words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1)
          }
        }
        return words.join(' ')
      }
    },
    truncate: (text: string, length?: number, clamp?: string) => {
      text = text || ''
      clamp = clamp || '...'
      length = length || 30

      if (text.length <= length) return text

      let tcText = text.slice(0, length - clamp.length)
      let last = tcText.length - 1

      while (last > 0 && tcText[last] !== ' ' && tcText[last] !== clamp[0]) last -= 1

      // Fix for case when text dont have any `space`
      last = last || length - clamp.length

      tcText = tcText.slice(0, last)

      return tcText + clamp
    },
  }
}
